<div class="searchPatient">
    <mat-form-field appearance="outline">
        <input matInput placeholder="Search here...." (keyup)="setFilter()" [(ngModel)]="searchText">
        <button mat-button matSuffix mat-icon-button (click)="openAdvanceFilter()">
            <mat-icon style="color: #000">filter_list</mat-icon>
            <div class="notify" *ngIf="isAdvanceFiltersApplied">
                <span class="point filter"></span>
            </div>
        </button>
    </mat-form-field>
    <mat-card @slowFadeIn class="m-0 advance-filter-container" *ngIf="showAdvanceFilterDropDown">
        <div fxLayoutAlign="end start">
            <button style="color: #000" class="b-0 close-btn pointer" type="reset" (click)="openAdvanceFilter()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div>
            <h3 class="m-0 m-b-10">Labels</h3>
            <div *ngIf="labels.length">
                <div fxLayout="row wrap" (click)="onSelectLabelItem(item)" fxLayoutAlign="start center"
                    *ngFor="let item of labels" class="m-b-10 pointer">
                    <div class="m-r-10 box" [ngStyle]="{'background': item.labelColor}">
                    </div>
                    <div class="list-item" [matTooltip]="item.labelText" fxFlex fxLayoutAlign="space-between center">
                        <span>{{item.labelText}}</span>
                        <mat-icon *ngIf="item.selected">done</mat-icon>
                    </div>
                </div>
            </div>
            <div *ngIf="!labels.length" class="msg">
                No labels available
            </div>
        </div>
    </mat-card>
</div>